import { FC } from "react";
import { DappDataType } from "../../utils/data";
import { CustomizedButton } from "../Buttons/CustomizedButton";

interface DappDataProps {
  dappData: DappDataType;
}
const DappCard: FC<DappDataProps> = ({ dappData }) => {
  return (
    <div className="mt-20">
      <div className="px-6">
        <div className="flex flex-wrap justify-center">
          <div className="w-full flex justify-center">
            <div className="">
              <img
                src={dappData.logo}
                className="shadow-xl rounded-full align-middle border-none -m-16 -ml-20 lg:-ml-16 max-w-[150px] min-w-[150px]"
                alt="logo"
              />
            </div>
          </div>
          <div className="w-full text-center mt-20">
            <div className="flex justify-center lg:pt-4 pt-8 pb-0">
              <div className="p-3 text-center">
                <span className="text-xl font-bold block uppercase tracking-wide text-slate-700">
                  {dappData.AdDeals}
                </span>
                <span className="text-sm text-slate-400">Ad Deals</span>
              </div>
              <div className="p-3 text-center">
                <span className="text-xl font-bold block uppercase tracking-wide text-slate-700">
                  {dappData.voters.length}
                </span>
                <span className="text-sm text-slate-400">Voters</span>
              </div>
              <div className="p-3 text-center">
                <span className="text-xl font-bold block uppercase tracking-wide text-slate-700">
                  {dappData.following}
                </span>
                <span className="text-sm text-slate-400">Following</span>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-2">
          <h3 className="text-2xl text-slate-700 font-bold leading-normal mb-1">
            {dappData.dappName}
          </h3>
          <div className=" text-xs mt-0 mb-2 py-5 text-slate-400 font-bold uppercase">
            <CustomizedButton text="View Details" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DappCard;
